import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";

import Title from "../../components/Title";

const DoorExternalPage = () => {
  const { t } = useTranslation(["door"]);

  return (
    <div className="d-flex align-items-center flex-column">
      <Title className="page-title home mb-5">
        <Typography variant="h1">{t(`door:external.title`)}</Typography>
      </Title>
      <Typography variant="h3" className="font-weight-regular mt-3">
        {t(`door:external.subtitle`)}
      </Typography>
    </div>
  );
};

export default DoorExternalPage;
